import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Bot } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { getBotStatus, setBotStatus } from "@/lib/dentiumApi";

export const BotToggle = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["bot-status"], queryFn: getBotStatus, refetchInterval: 15000 });
  const enabled = data?.enabled ?? true;

  const toggle = useMutation({
    mutationFn: setBotStatus,
    onSuccess: (d) => {
      qc.setQueryData(["bot-status"], d);
      if (d.enabled) toast.success("Bot activo", { description: "Vuelve a responder automáticamente en WhatsApp e Instagram." });
      else toast.warning("Bot pausado", { description: "No responderá automáticamente. Los mensajes se guardan y se avisará al equipo." });
    },
    onError: () => toast.error("No se pudo cambiar el estado del bot"),
  });

  return (
    <label
      data-testid="bot-toggle"
      title={data?.updated_by ? `Último cambio: ${data.updated_by}` : undefined}
      className={`flex items-center gap-2.5 rounded-full border pl-3 pr-2 py-1.5 cursor-pointer transition-colors ${
        enabled ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-red-50 border-red-200 text-red-700"
      }`}
    >
      <Bot className="h-4 w-4" />
      <span data-testid="bot-toggle-label" className="text-sm font-semibold whitespace-nowrap">
        {enabled ? "Bot activo" : "Bot pausado"}
      </span>
      <Switch
        data-testid="bot-toggle-switch"
        checked={enabled}
        disabled={toggle.isPending || !data}
        onCheckedChange={(v) => toggle.mutate(v)}
        className="data-[state=checked]:bg-emerald-600 data-[state=unchecked]:bg-red-400"
      />
    </label>
  );
};
